async function ensureCostiesBlockedOnline() {
  try {
    await fetch(KROWN.settings.routes.cart_update_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          costies_block_online: 'true'
        }
      })
    });
  } catch (e) {
    console.error('Unable to set costies_block_online cart attribute', e);
  }
}

if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {
constructor(){
  super();
  this.ajaxifyCartItems();
  ensureCostiesBlockedOnline();
}
		connectedCallback(){
			document.addEventListener('click', (e) => {
				const clearCartLink = e.target.closest('[data-action="clear-cart"]');
				if (clearCartLink) {
				  e.preventDefault();
				  this.clearCart();
				}
			  }
			);
		}

		disconnectedCallback(){
			document.removeEventListener('click', (e) => {
				const clearCartLink = e.target.closest('[data-action="clear-cart"]');
				if (clearCartLink) {

				  e.preventDefault();
				  this.clearCart();
				}
			  }
			);
		}


		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 300));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		clearCart() {
this.form.classList.add('processing');
fetch(KROWN.settings.routes.cart_clear_url, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' }
})
.then(response => {
  if (response.ok) {
    return ensureCostiesBlockedOnline().then(() => response);
  } else {
    throw new Error('Erreur lors de la suppression du panier');
  }
})
.then(() => {
  return fetch('?section_id=helper-cart');
})
			.then(response => response.text())
			.then(text => {
			  const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			  const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			  const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			  // Met à jour le contenu du panier dans la page sans recharger
			  const cartItems = document.getElementById('AjaxCartForm');
			  cartItems.innerHTML = cartFormInnerHTML;
			  cartItems.ajaxifyCartItems();  // Réinitialise l'ajaxification

			  // Met à jour les totaux du panier dans l'en-tête et le sous-total
			  document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			  });
			  document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			  });

			  document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

			  // Événements personnalisés et autres actions post-suppression
			  const event = new Event('cart-updated');
			  this.dispatchEvent(event);
			  InitSubmit();
			  displayDonationMessageCartDrawer();
			})
			.finally(() => {
			  this.form.classList.remove('processing');
			})
			.catch(error => {
			  console.error(error);
			  let alert = document.createElement('span');
			  alert.classList.add('alert', 'alert--error');
			  alert.textContent = KROWN.settings.locales.cart_general_error;
			  this.form.prepend(alert);
			});
		  }

		updateCartQty(item, newQty){

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				id: item.dataset.id,
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
.then(response => {
  if (response.ok) {
    return ensureCostiesBlockedOnline().then(() => fetch('?section_id=helper-cart'));
  } else {
    throw new Error('Something went wrong');
  }
})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					
					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( newQty != 0 && cartItems.querySelector(`[data-js-cart-item][data-id="${item.dataset.id}"]`) && newQty > parseInt(cartItems.querySelector(`[data-js-cart-item][data-id="${item.dataset.id}"]`).dataset.qty) ) {
						let alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						alert.innerHTML = KROWN.settings.locales.cart_add_error.replace('{{ title }}', item.dataset.title);
						this.form.prepend(alert);
					}

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

					const event = new Event('cart-updated');
					this.dispatchEvent(event);
					InitSubmit();
          displayDonationMessageCartDrawer()
				})
				.then(() => {

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}
	}


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus')?.addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			this.setAttribute('data-quantity', this.querySelector('.qty').value)
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

if ( typeof CartDetails !== 'function' ) {

  class CartDetails extends HTMLElement {
    constructor(){
      super();
      this.footer = document.querySelector('.shopify-section .footer');
      if (this.footer) {
        this.init();
      }
    }

    init() {
      this.handleScroll = this.handleScroll.bind(this);
      this.handleScroll();
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleScroll);
    }

    handleScroll() {
      if (!this.footer) return;
      const footerRect = this.footer.getBoundingClientRect();
      const footerTop = footerRect.top;
      const viewportMiddle = window.innerHeight / 2;

      if (footerTop <= viewportMiddle) {
        this.classList.add('invisible');
      } else {
        this.classList.remove('invisible');
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
    }
  }

  if ( typeof customElements.get('cart-details') == 'undefined' ) {
    customElements.define('cart-details', CartDetails);
  }

}

// method for apps to tap into and refresh the cart


if ( ! window.refreshCart ) {

  window.refreshCart = () => {
    ensureCostiesBlockedOnline()
      .then(() => {
        return fetch(`${window.location.href}?section_id=helper-cart`);
      })
      .then(response => response.text())
      .then(text => {

        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
        const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
        const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

        const cartItems = document.getElementById('AjaxCartForm');
        cartItems.innerHTML = cartFormInnerHTML;
        cartItems.ajaxifyCartItems();

        document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
          elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
        });

        document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
          elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
        });

        document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

        if (document.querySelector('[data-js-site-cart-sidebar]')) {
          document.querySelector('[data-js-site-cart-sidebar]').show();
        }

        if (document.querySelector('cart-recommendations')) {
          document.querySelector('cart-recommendations').innerHTML = '';
          document.querySelector('cart-recommendations').generateRecommendations();
        }

        checkShoppingInsurance();
        addCartNote();
        ShippingBar();
      })
      .catch(e => {
        console.error(e);
      });
  };

}